<template>
  <ApplicationLayout>
    <v-container
      fluid
      px-12
      py-6
    >
      <div
        class="
          d-flex
          pb-6
          align-center
        "
      >
        <h2
          class="display-1"
        >Categories</h2>

        <v-spacer></v-spacer>

        <TableSearch
          label="Search categories"
          v-model="search"
          @input="doSearch"
        ></TableSearch>

        <NewButton
          to-name="new-category"
          class="ml-6"
        >Create new category</NewButton>
      </div>

      <v-data-table
        :headers="headers"
        :items="categories"
        :page="page"
        :items-per-page="itemsPerPage"
        :sort-by.sync="sortBy"
        @update:sort-by="updatePagination"
        :sort-desc.sync="sortDesc"
        @update:sort-desc="updatePagination"
        multi-sort
        hide-default-footer
        :loading="loading"
        @page-count="pageCount = $event"
        @click:row="goToCategory"
      >
        <template v-slot:item.updated_at="{ item }">
          <span
            class="text-no-wrap"
            :id="`focus_${item.id}`"
          >
            {{ new Date(item.updated_at).toLocaleDateString() }}
          </span>
        </template>

        <template v-slot:item.created_at="{ item }">
          <span class="text-no-wrap">
            {{ new Date(item.created_at).toLocaleDateString() }}
          </span>
        </template>
      </v-data-table>

      <div
        class="py-6"
      >
        <TablePagination
          v-model="page"
          @input="updatePagination"
          :itemsPerPage.sync="itemsPerPage"
          @update:itemsPerPage="updatePagination"
          :pageCount.sync="pageCount"
          :total="categories.length"
        ></TablePagination>
      </div>
    </v-container>
  </ApplicationLayout>
</template>

<script>
import { mapState } from 'vuex'
import ApplicationLayout from '../components/layouts/ApplicationLayout.vue'
import TableSearch from '../components/TableSearch.vue'
import NewButton from '../components/NewButton.vue'
import TablePagination from '../components/TablePagination.vue'

export default {
  components: {
    ApplicationLayout,
    TableSearch,
    NewButton,
    TablePagination
  },
  data() {
    const { itemsPerPage, sortBy, sortDesc, search } = this.$pagination.getOptions('categories')
    return {
      search,
      pageCount: 0,
      page: 1,
      loading: true,
      itemsPerPage,
      sortBy,
      sortDesc,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Last update', value: 'updated_at' },
        { text: 'Creation date', value: 'created_at' }
      ]
    }
  },
  computed: {
    ...mapState('Categories', ['categories'])
  },
  async created() {
    await this.$store.dispatch('Categories/getAll', { search: this.search })
    const { page } = this.$pagination.getOptions('categories')
    this.page = page
    this.$pagination.focus()
    this.updatePagination()
    this.loading = false
  },
  methods: {
    updatePagination() {
      this.$pagination.update({
        itemsPerPage: this.itemsPerPage,
        page: this.page,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        search: this.search
      }, 'categories')
    },
    goToCategory(category) {
      this.$router.push({
        name: 'category',
        params: { id: category.id }
      })
    },
    async doSearch() {
      this.page = 1
      this.loading = true
      await this.$store.dispatch('Categories/getAll', { search: this.search })
      this.loading = false
      this.updatePagination()
    }
  }
}
</script>
